import React, {Component} from "react";
import {Link} from "react-router-dom";
import {Row} from "react-bootstrap";
import ReactTableWrapperUsers from "../Table/ReactTableWrapperUsers";

class UsersContainer extends Component {
    render() {
        return (
            <div className="card">
                <div className="content">
                    <div className="panel-body">
                        <Row className="users-table-header">
                            <div className="header-content">
                                <h4 className="card-title">
                                    {this.props.title}{' '}
                                    ({this.props.translate('user:numOfnum', {
                                    num1: this.props.allUsers.length.toString(),
                                    num2: this.props.allLicenses.toString()
                                })})
                                </h4>
                                <div className="Bar-btn-container">
                                    <Link
                                        to={{
                                            pathname: "/admin/Settings/createUser",
                                            state: { createUser: true }
                                        }}
                                        className="btn btn-default NavBar-btn btn-md knoa-region"
                                    >
                                        {this.props.translate('common:newUser')}
                                    </Link>
                                </div>
                            </div>
                        </Row>
                        <div className="knoa-region" tabIndex={"-1"}>
                            <ReactTableWrapperUsers
                                users={this.props.allUsers}
                                t={this.props.translate}
                                handleUnlock={this.props.handleUnlockWindow}
                                handleDelete={this.props.handleShow}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default UsersContainer;